// ADR-0163 (#0770) — el jefe convierte una consulta del propietario en
// observación: la sugerencia de la IA (sólo a pedido, sin escribir nada) y
// la conversión (requiere Idempotency-Key). Se parsea el wire (ADR-0021/D6).

import {
  ownerInquiryConversionResponseSchema,
  ownerInquiryConversionSuggestionResponseSchema,
  type OwnerInquiryConversionRequest,
  type OwnerInquiryConversionResponse,
  type OwnerInquiryConversionSuggestionRequest,
  type OwnerInquiryConversionSuggestionResponse,
} from "@bitacorapro/api-types";
import { request } from "../client";

const base = (id: string) => `/owner-inquiries/${encodeURIComponent(id)}/conversion`;

/** POST …/conversion/suggestion — sin Idempotency-Key (no escribe nada). */
export async function suggestOwnerInquiryConversion(
  id: string,
  body: OwnerInquiryConversionSuggestionRequest
): Promise<OwnerInquiryConversionSuggestionResponse> {
  const json = await request<unknown>("POST", "core", `${base(id)}/suggestion`, { body });
  return ownerInquiryConversionSuggestionResponseSchema.parse(json);
}

/** POST …/conversion — un reintento con la misma clave devuelve la misma
 *  conversión sin reenviar avisos. */
export async function convertOwnerInquiry(
  id: string,
  body: OwnerInquiryConversionRequest,
  opts: { idempotencyKey: string }
): Promise<OwnerInquiryConversionResponse> {
  const json = await request<unknown>("POST", "core", base(id), {
    body,
    headers: { "Idempotency-Key": opts.idempotencyKey },
  });
  return ownerInquiryConversionResponseSchema.parse(json);
}
